import { forwardRef } from 'react';
import { head, join, split, tail } from 'lodash';
import { Text } from '@chakra-ui/react';
import { AssistantQuery } from '@/components/dashbaord/assistant/types.ts';

interface ImportantQueryListItemProps {
	item: AssistantQuery;
}

export const ImportantQueryListItem = forwardRef<HTMLDivElement, ImportantQueryListItemProps>(({ item }, ref) => {
	const words = split(item.text, ' ');
	const firstWord = head(words);
	const remainingWords = tail(words);
	const remainingText = join(remainingWords, ' ');

	return (
		<Text ref={ref} w="100%" fontSize={{ base: 'xs', md: 'xs' }} fontWeight="semibold" textAlign="left">
			<Text as="span" color="primary/34">
				{firstWord}
			</Text>
			{remainingText && <Text as="span">{' ' + remainingText}</Text>}
		</Text>
	);
});

ImportantQueryListItem.displayName = 'ImportantQueryListItem';
